import * as React from 'react'

import { Header } from 'tabler-react'

const ErrorPageNoJob = props => {
  const {
    title,
    subtitle,
    details
  } = props

  return(
    <div className="text-center">
      <Header.H1 className="display-1 text-muted mb-5">{title}</Header.H1>
      <Header.H2>{subtitle}</Header.H2>
      {details && (
        <Header.H4 className="text-muted font-weight-normal mb-7">
          {details}
        </Header.H4>
      )}
    </div>
  )
}

export default ErrorPageNoJob